package xim.resource.table

// https://github.com/LandSandBoat/server/blob/base/sql/pet_skills.sql
object PetSkillInfoTable {

    val skillIdToAnimationId = mapOf(
        353 to 2213,
        354 to 2211,
        355 to 2212,
        512 to 0,
        513 to 1,
        514 to 2,
        515 to 3,
        516 to 4,
        517 to 5,
        518 to 6,
        519 to 7,
        520 to 8,
        521 to 161,
        522 to 162,
        523 to 163,
        524 to 164,
        525 to 159,
        526 to 160,
        527 to 170,
        528 to 16,
        529 to 17,
        530 to 18,
        531 to 20,
        532 to 19,
        533 to 22,
        534 to 21,
        536 to 24,
        537 to 25,
        538 to 26,
        539 to 27,
        544 to 32,
        545 to 33,
        546 to 34,
        547 to 35,
        548 to 36,
        549 to 37,
        550 to 38,
        551 to 39,
        552 to 40,
        553 to 41,
        554 to 42,
        560 to 48,
        561 to 49,
        562 to 50,
        563 to 51,
        564 to 52,
        565 to 53,
        566 to 54,
        567 to 55,
        568 to 56,
        569 to 57,
        570 to 58,
        576 to 64,
        577 to 65,
        578 to 66,
        579 to 67,
        580 to 68,
        581 to 69,
        582 to 70,
        583 to 71,
        584 to 72,
        585 to 73,
        586 to 74,
        592 to 80,
        593 to 81,
        594 to 82,
        595 to 83,
        596 to 84,
        597 to 85,
        598 to 86,
        599 to 87,
        600 to 88,
        601 to 89,
        602 to 90,
        608 to 96,
        609 to 97,
        610 to 98,
        611 to 99,
        612 to 100,
        613 to 101,
        614 to 102,
        615 to 103,
        616 to 104,
        617 to 105,
        618 to 106,
        624 to 112,
        625 to 113,
        626 to 114,
        627 to 115,
        628 to 116,
        629 to 117,
        630 to 118,
        631 to 119,
        632 to 120,
        633 to 121,
        634 to 122,
        639 to 156,
        640 to 128,
        641 to 129,
        642 to 130,
        643 to 131,
        644 to 132,
        645 to 133,
        646 to 134,
        647 to 135,
        648 to 136,
        649 to 137,
        650 to 138,
        651 to 139,
        652 to 140,
        653 to 157,
        654 to 158,
        656 to 141,
        657 to 142,
        658 to 146,
        659 to 144,
        660 to 143,
        661 to 145,
        662 to 148,
        664 to 149,
        665 to 153,
        666 to 155,
        667 to 173,
        671 to 152,
        672 to 1,
        673 to 2,
        674 to 3,
        675 to 44,
        676 to 45,
        677 to 46,
        678 to 49,
        679 to 50,
        680 to 14,
        681 to 15,
        682 to 17,
        683 to 110,
        684 to 111,
        685 to 112,
        686 to 113,
        687 to 116,
        688 to 117,
        689 to 4,
        690 to 5,
        691 to 6,
        692 to 8,
        693 to 186,
        694 to 187,
        695 to 188,
        696 to 189,
        697 to 192,
        698 to 65,
        699 to 66,
        700 to 52,
        701 to 53,
        702 to 54,
        703 to 55,
        704 to 56,
        705 to 58,
        706 to 59,
        707 to 82,
        708 to 83,
        709 to 84,
        710 to 85,
        711 to 87,
        712 to 403,
        713 to 404,
        714 to 809,
        715 to 810,
        716 to 811,
        717 to 813,
        718 to 806,
        719 to 808,
        720 to 807,
        721 to 815,
        722 to 816,
        723 to 817,
        724 to 818,
        725 to 814,
        726 to 830,
        727 to 831,
        728 to 833,
        729 to 832,
        730 to 397,
        731 to 396,
        732 to 158,
        733 to 161,
        734 to 970,
        735 to 37,
        736 to 1576,
        737 to 1579,
        738 to 1577,
        740 to 159,
        741 to 164,
        743 to 124,
        744 to 118,
        745 to 123,
        746 to 291,
        747 to 1573,
        748 to 1574,
        749 to 910,
        750 to 911,
        751 to 913,
        752 to 914,
        753 to 478,
        754 to 479,
        755 to 481,
        756 to 1160,
        757 to 1161,
        758 to 193,
        759 to 973,
        760 to 197,
        772 to 401,
        773 to 9,
        790 to 289,
        791 to 1986,
        795 to 17,
        796 to 98,
        797 to 910,
        798 to 912,
        960 to 175,
        961 to 176,
        964 to 179,
        967 to 182,
        968 to 183,
        970 to 185,
    )

}